import React from "react";

export const Logo = ({ className = "", showText = true }) => {
    return (
        <div className={`flex items-center gap-3 ${className}`} data-testid="helixora-logo">
            <div className="relative">
                <svg width="30" height="34" viewBox="0 0 40 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    {/* Double-helix motif — HELIXora */}
                    <path d="M10 4 C 26 12, 26 18, 10 26 C 26 34, 26 40, 10 40"
                        stroke="#10B981" strokeWidth="1.6" fill="none" strokeLinecap="round" />
                    <path d="M30 4 C 14 12, 14 18, 30 26 C 14 34, 14 40, 30 40"
                        stroke="#D4AF37" strokeWidth="1.6" fill="none" strokeLinecap="round" />
                    {/* Rungs */}
                    {[8, 14, 20, 26, 32, 38].map((y, i) => (
                        <line key={i} x1="12" y1={y} x2="28" y2={y} stroke="#F5F5F5" strokeOpacity="0.35" strokeWidth="0.8" />
                    ))}
                </svg>
            </div>
            {showText && (
                <div className="flex flex-col leading-none">
                    <span className="font-display text-[16px] font-bold tracking-tight text-ink">HELIXORA<span className="text-neon">.</span>PEPTIDES</span>
                    <span className="overline text-[8.5px] text-ink-mute mt-1">LAB-VERIFIED · RESEARCH GRADE</span>
                </div>
            )}
        </div>
    );
};
